import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/share.svg';

export const IconShare = createIconComponent(Icon);
